export const FORBIDDEN_EXACT = [
    "home", "about", "aboutus", "linkerto", "404", "setting", "settings",
    "documentation", "docs", "dashboard", "credentials", "passwordreset",
    "sendpasswordreset", "profile", "logout", "login", "signup",
    "termsandconditions", "privacypolicy", "linkertome", "linkertocom",
    "usersettings", "page", "create", "announcements", "contact", "contactus",
    "config", "updates", "changelog", "admin", "api", "auth", "status",
    "help", "support", "terms", "privacy", "legal", "security", "billing",
    "upgrade", "verify", "pro", "enterprise", "careers", "jobs", "team",
    "blog", "news", "pricing", "null", "undefined",
    "me", "analytics", "preview", "plans", "subscribe", "checkout", "payment",
    "app", "embed", "og", "meta", "webhook", "webhooks", "assets", "static",
    "cdn", "www",
];

export const FORBIDDEN_PARTIAL = [
    "xxx", "xvideos", "xnxx", "porn", "nsfw", "nude", "sex", "hentai",
    "linkerto",
];
